import { detect } from 'detect-browser';

export function getOSInfo() {
  const browser = detect();

  return browser?.os;
}
